export default __webpack_public_path__ + "static/media/cover-thumbnail.610b1007.png";